var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import FlowUtil from './../FlowUtil';
/*
 * This component has 2 responsibilities
 * 1) To hook up a flow step to a router state so that step transitions in the flow trigger the correct router transitions
 * 2) Clean-up the flowModel object from the state data when we transition to an exit step or go to a non-flow router state
 */
export default function ($state, StateUtils, parentWizardState, stepToStateMapping) {
    // Check if there has been a router transition that is going from a wizard state to non-wizard state as result of
    // a router state change (user clicks on home page link for example) rather than moving to a flow exit.
    // Prompt user that they are exiting wizard and call the cancel action
    var routerExitListenerRemoveFn = StateUtils.beforeStateChangeStart(function (event, toState, toParams, fromState) {
        if (ifExitingWizardState(fromState, toState)) {
            if (toState.data && toState.data.isAuthPage) {
                cleanupWizardStateData();
            } else {
                // initially prevent transition until we get confirmation
                event.preventDefault();
                var wizardStateData = StateUtils.dataForState(parentWizardState);
                var visitedSteps = wizardStateData.flowModel.visitedSteps.map(function (step) {
                    return step.name;
                });
                wizardStateData.flowModel.cancel(wizardStateData.model, { visitedSteps: visitedSteps }).then(function () {
                    cleanupWizardStateData();
                    $state.go(toState, toParams);
                });
            }
        }
    });

    function setModelData(model) {
        var wizardStateData = StateUtils.dataForState(parentWizardState);
        wizardStateData.model = model;
    }

    function cleanupWizardStateData() {
        var stateData = StateUtils.dataForState(parentWizardState);
        if (stateData.flowModel) {
            stateData.flowModel.removeAllStepChangeListeners();
        }
        StateUtils.removeDataForState(parentWizardState, ['flowModel', 'model'], true);
        routerExitListenerRemoveFn();
    }

    function ifExitingWizardState(fromState, toState) {
        var fromStateInWizard = StateUtils.hasState(parentWizardState, fromState);
        var toStateInWizard = StateUtils.hasState(parentWizardState, toState);
        return fromStateInWizard && !toStateInWizard;
    }

    return function (flowDefn) {
        /*
         * Step change listener callback
         */
        return function (model, fromStep, nextStep, extraArgs) {
            // default routing is to go to state with same name as step
            nextStep = FlowUtil.getStepOrJunctionObject(nextStep);
            var nextState = nextStep.name;
            var nextStateArgs = extraArgs;
            var specificRouterHandler = stepToStateMapping[nextStep.name];
            if (specificRouterHandler) {
                var _specificRouterHandle = specificRouterHandler(model, nextStep, fromStep, extraArgs);

                var _specificRouterHandle2 = _slicedToArray(_specificRouterHandle, 2);

                nextState = _specificRouterHandle2[0];
                nextStateArgs = _specificRouterHandle2[1];
            }

            // if exiting wizard clean up data held in top level wizard state
            if (flowDefn.exits[nextStep.name]) {
                cleanupWizardStateData();
            } else {
                // Ideally we would pass model data as a parameter instead of using the state data but ui-router copies
                // parameter object instead of using the object reference.This causes problems for objects like view model
                // which initialise properties in the object constructor
                setModelData(model);
            }

            $state.go(nextState, nextStateArgs);
        };
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/flow/angularhelpers/RouterStepChangeListener.js
// module id = 754
// module chunks = 0